import "./Top.css";
import Nav from '../../components/Nav'
import Name from "../../components/Name";

function Top() {
  return (
    <div className="top">
      <Nav />
      <Name />
    </div>
  );
}

export default Top;